import { Image, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import { DeactivatedLabel, Price } from '../../commonComponents';
import { IOfferItemProps } from '../../types';
import { DefaultPreview } from '../DefaultPreview';
import { DescriptionItem } from '../DescriptionItem';
import { WalkWayMinutes } from '../WalkWayMinutes';
import * as styles from './styles.css';

export const OfferItem: React.FC<IOfferItemProps> = props => {
  const { onOfferClick, testId, offer } = props;

  return (
    <div className={styles['container']} onClick={onOfferClick} data-testid={testId}>
      <div className={styles['top']}>
        <div className={styles['image']}>
          {offer.previewPhoto ? (
            <Image width={150} height={150} objectFit="cover" src={offer.previewPhoto} />
          ) : (
            <DefaultPreview />
          )}
        </div>
        <div className={styles['info']}>
          {offer.deactivatedTitle && <DeactivatedLabel title={offer.deactivatedTitle} />}
          <UIHeading4 color="text-main-default">{offer.title}</UIHeading4>
          {offer.walkWayMinutes && <WalkWayMinutes>{offer.walkWayMinutes}</WalkWayMinutes>}
          <div className={styles['price']}>
            <Price diff={offer.prices.priceDiff} subprice={offer.prices.priceSqm} size="XS">
              {offer.prices.price}
            </Price>
          </div>
        </div>
      </div>
      <div className={styles['description']}>
        <DescriptionItem title="На Циан" value={offer.exposition} />
        <DescriptionItem title="Опубликовано" value={offer.dateStart} />
        <DescriptionItem title="Снято" value={offer.dateEnd || '–'} />
      </div>
    </div>
  );
};
